<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica provvigione' : 'Nuova provvigione' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-commission-form [data]="data"></app-commission-form>
</div>
